import { render } from "./MetricNew.vue?vue&type=template&id=37074e51&scoped=true"
import script from "./MetricNew.vue?vue&type=script&lang=js"
export * from "./MetricNew.vue?vue&type=script&lang=js"

import "./MetricNew.vue?vue&type=style&index=0&id=37074e51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37074e51"]])

export default __exports__